import $ from 'jquery';
import 'bootstrap';
import AOS from '@/components/aos';
import '@fancyapps/fancybox';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.zh-TW.min';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import 'nouislider/distribute/nouislider.css';
import 'select2/dist/css/select2.min.css';
import 'scrolltofixed';
import 'select2';
import { setGA } from '@/utils/util-extent';
import objectFitImages from 'object-fit-images';

import './components/input-select';
import '@/vendors/jquery.address.min';
import './components/theModel-extent';


import '~/sass/global.scss';
import '~/sass/icons/toyota-2016.scss';
import '~/sass/icons/toyota-2020.scss';

// const swiperHistory = null;
let initScrollTop = $(document).scrollTop();
const initWindowWidth = $(window).outerWidth();
const initWindowHeight = $(window).innerHeight();
const navHeight = 0;
// console.log(initWindowWidth);
$.fancybox.defaults.autoFocus = false;
$.fancybox.defaults.touch = false;


const heightVH = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const $someImages = $('.list-img img, article.car-show-list img, article.history-cars-info img, article.img-subtext-swiper img, .kv-image');

function initUserID() {
  const num = $('#seqIndex').val();
  if (num !== '') {
    setGA(num);
  }
}

$(document).ready(() => {
  console.log('page init');
  heightVH();

  $('.scroll-menu-list li').click(function scroll() {
    let pos = $(this).position().left;
    const posWidth = $(this).width();
    const currentscroll = $(this).parent().scrollLeft();
    const divwidth = $(this).parent().width();
    pos = (pos + currentscroll) - (divwidth / 2) + (posWidth / 2) + 10;

    $(this).parent().animate({
      scrollLeft: pos,
    });
  });

  initUserID();

  objectFitImages($someImages);

  AOS.init({
    once: true,
  });
});

$(window).scroll(() => {
  const scrolled = $(document).scrollTop();
  if (initWindowWidth < 1024) {
    if (scrolled > navHeight) {
      $('.fixed-menu').addClass('hide');
      $('.fixed-menu-mobile').removeClass('quick-show');
    } else {
      $('.fixed-menu').removeClass('hide');
      $('.fixed-menu-mobile').addClass('quick-show');
    }
    if (scrolled > initScrollTop) {
      $('.fixed-menu').removeClass('sticky');
      $('.fixed-menu-mobile').removeClass('quick-show');
    } else {
      $('.fixed-menu').addClass('sticky');
      $('.fixed-menu-mobile').addClass('quick-show');
    }

    if (scrolled > navHeight) {
      if ($('.fixed-menu').hasClass('hide')) {
        const windowH = $('body,html').offset().top
            + $('body,html').outerHeight()
            - window.innerHeight
            - 100;
          // console.log(scrolled,windowH)
        if (scrolled >= windowH) {
          $('.fixed-menu').removeClass('hide');
          $('.fixed-menu-mobile').addClass('quick-show');
        } else {
          $('.fixed-menu').addClass('hide');
          // $('.fixed-menu-mobile').addClass('quick-show');
        }
      }
    }
    initScrollTop = $(document).scrollTop();
  }
  if (scrolled > initWindowHeight - 72) {
    $('#gotop-mobile').fadeIn(300);
    $('.fixed-menu .go-to-top').parent().addClass('d-lg-block');
  } else {
    $('#gotop-mobile').fadeOut(200);
    $('.fixed-menu .go-to-top').parent().removeClass('d-lg-block');
  }
});

window.addEventListener('resize', () => {
  heightVH();
});
